let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("3yAl4"), load("76n7a"), load("l253H"), load("kNFvF"), load("ffQaD"), load("kvRbA"), load("jqTxj")]).then(() => parcelRequire('lfpoU'));